export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7261.c479694f.jpg";